var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vca-dropdown',{ref:"from",attrs:{"options":_vm.senderList,"label":"","rules":_vm.$v.value.from,"errorMsg":_vm.$t('email.sender.errorMsg'),"placeholder":_vm.$t('email.sender.placeholder')},model:{value:(_vm.sender),callback:function ($$v) {_vm.sender=$$v},expression:"sender"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }